import isEqual from 'lodash/fp/isEqual';
import { User } from '@frx/frx-react-context';
import { GetParticipantsResponse, Participant } from '@frx/frx-services';

export interface PhotoResponse {
  data: {
    consId: string;
    thumbnailUrl: string;
  };
}

export interface TeamMemberProps {
  memberDisplayName: string;
  amountRaised: number;
  photoUrl: string;
}

export const isATeamCaptain = (
  teams: GetParticipantsResponse | undefined,
  user: User | undefined
) =>
  (teams?.participant || []).find(
    (member: Participant) => member.consId === user?.cons_id
  )?.aTeamCaptain;

export const getPhotoUrl = (response: any, id: number): string => {
  const photo = (response as PhotoResponse[]).find((p) =>
    isEqual(p?.data?.consId, String(id))
  );
  return photo?.data?.thumbnailUrl || '';
};

export const getTeamMembers = (
  teams: GetParticipantsResponse | undefined,
  photos: PhotoResponse[]
): TeamMemberProps[] =>
  (teams?.participant || []).map((member: Participant) => ({
    memberDisplayName:
      member.name.screenname || `${member.name.first} ${member.name.last}`,
    amountRaised: member.amountRaised,
    photoUrl: getPhotoUrl(photos, member.consId),
  }));
